import { render, staticRenderFns } from "./ConfirmAddDocumentModal.vue?vue&type=template&id=f7d45b46&scoped=true&"
import script from "./ConfirmAddDocumentModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmAddDocumentModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAddDocumentModal.vue?vue&type=style&index=0&id=f7d45b46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7d45b46",
  null
  
)

export default component.exports